const scrollTopBtn = document.querySelector('.btn--back-to-top');

let viewportWidth;

let setViewportWidth = function () {
    viewportWidth = window.innerWidth || document.documentElement.clientWidth;
};

window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    if (scrollTopBtn) {
        if (viewportWidth > 992 && document.body.scrollTop > 3200 || document.documentElement.scrollTop > 3200) {
            scrollTopBtn.classList.add('active');
        } else if (viewportWidth < 992 && document.body.scrollTop > 2700 || document.documentElement.scrollTop > 2700) {
            scrollTopBtn.classList.add('active');
        } else {
            scrollTopBtn.classList.remove('active');
        }
    }
}

if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function () {
        window.scrollTo ({
            top: 0,
            behavior: 'smooth',
        });
    });
}